var exports = {
  "O5": "Features__H7XDAB",
  "nu": "Features__container__P4Pa42",
  "gb": "Features__tablesWrapper__kqYnw9",
};

module.exports = exports;
